import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    ClientPaymentApproverCandidate,
    ClientPaymentApproverCandidatesRequest,
    PaymentRepository,
} from '../../Core-Repositories/payment.repository';

export interface ClientPaymentApproverPickerState {
    candidates: ClientPaymentApproverCandidate[];
    includeAllCompanyContacts: boolean;
    autoExpandedToAllContacts: boolean;
    selectedContactId: number;
}

@Injectable({ providedIn: 'root' })
export class ClientPaymentApproverPickerService {
    constructor(private readonly paymentRepository: PaymentRepository) {}

    static readonly showAllSessionStorageKey = 'clientPaymentApproverPicker.showAllCompanyContacts';

    async loadInitial(request: ClientPaymentApproverCandidatesRequest): Promise<ClientPaymentApproverPickerState> {
        const eligibleState = await this.load(request, false, null);
        if (eligibleState.candidates.length === 0) {
            const allContactsState = await this.load(request, true, null);
            return { ...allContactsState, autoExpandedToAllContacts: true };
        }

        if (sessionStorage.getItem(ClientPaymentApproverPickerService.showAllSessionStorageKey) === 'true') {
            return this.load(request, true, null);
        }

        return eligibleState;
    }

    async load(
        request: ClientPaymentApproverCandidatesRequest,
        includeAllCompanyContacts: boolean,
        selectedContactId: number,
    ): Promise<ClientPaymentApproverPickerState> {
        const response = await lastValueFrom(
            this.paymentRepository.getClientPaymentApproverCandidates({ ...request, includeAllCompanyContacts }),
        );
        const candidates = response?.candidates ?? [];
        return {
            candidates,
            includeAllCompanyContacts,
            autoExpandedToAllContacts: false,
            selectedContactId: candidates.some((candidate) => candidate.contactId === selectedContactId)
                ? selectedContactId
                : null,
        };
    }

    saveShowAllPreference(includeAllCompanyContacts: boolean): void {
        sessionStorage.setItem(
            ClientPaymentApproverPickerService.showAllSessionStorageKey,
            includeAllCompanyContacts ? 'true' : 'false',
        );
    }
}
